<!--
 * @Author:
 * @Description: KAFKA历史数据重消费
-->
<template>
  <el-card class="h-full" :body-style="{ height: '100%' }">
    <el-row class="flex">
      <span class="flex items-center h-36px mr-10px">补采时间范围:</span>
      <el-date-picker
        class="w-400px mr-10px"
        v-model="timeRange"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <el-button size="small" type="primary" :loading="collectLoading" @click="collect"
        >开始采集</el-button
      >
      <el-button size="small" type="primary" :loading="collectLoading" @click="check"
        >查看进度</el-button
      >
    </el-row>
    <el-row class="pt-20px">
      <el-progress
        v-if="displayCircle"
        type="circle"
        :percentage="collectionProgress"
      ></el-progress>
    </el-row>
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import configManagementService from '@/services/configManagementService'
import { isNil } from 'lodash'

export default {
  name: 'historical-data',
  components: {},
  computed: {},
  data() {
    return {
      collectionProgress: 0,
      timeRange: '',
      displayCircle: false,
      collectLoading: false,
      progressKey: '',
      pickerOptions: {
        disabledDate(time) {
          const nowTime = Date.now()
          const seven = 7 * 24 * 60 * 60 * 1000
          const daysAgo = nowTime - seven
          return time.getTime() > nowTime || time.getTime() < daysAgo
        },
      },
    }
  },
  created() {},
  methods: {
    // 开始采集
    async collect() {
      if (this.timeRange) {
        const a = dayjs(this.timeRange[0])
        const b = dayjs(this.timeRange[1])
        const dif = b.diff(a, 'minute', true)
        if (dif > 60) {
          this.$message.warning('开始结束时间最大间隔1h')
        } else {
          this.collectLoading = true
          const res = await configManagementService.collectHistoryData({
            start: this.timeRange[0],
            end: this.timeRange[1],
          })
          this.collectLoading = false
          if (res && res.code === 0) {
            this.$message.success('补录开始，请等待...')
            this.progressKey = res.data
          }
        }
      } else {
        this.$message.warning('请选择时间段(时间间隔<1h)')
      }
    },
    // 查看进度
    async check() {
      if (!this.progressKey) {
        this.$message.warning('请先开始采集')
        return
      }
      const res = await configManagementService.getCollectHistoryDataProgress({
        key: this.progressKey,
      })
      if (res && res.code === 0) {
        if (isNil(res.data)) {
          this.displayCircle = true
          this.collectionProgress = 100
          this.$message.success(res.msg)
        } else {
          this.displayCircle = true
          this.collectionProgress = res.data
          this.$message.info(res.msg)
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">

</style>
